<template>
  <div class="radio">
    <label>
      <input type="radio"
        :value="value"
        :val="val"
        :name="name"
        :checked="val === value"
        @change="$emit('change', value)">
      <span class="cr">
        <i class="cr-icon fa fa-circle"></i>
      </span>
      <slot name="label"></slot>
    </label>
  </div>
</template>

<script>
  export default {
    props: ['value', 'label', 'checked', 'name', 'val'],
    model: {
      prop: 'val',
      event: 'change',
    },
  };
</script>

<style lang="scss" scoped>
.radio {
  label {
    padding-left: 10px;
    &:after {
      content: '';
      display: table;
      clear: both;
    }
  }
  .cr {
    position: relative;
    display: inline-block;
    border: 1px solid #a9a9a9;
    border-radius: .25em;
    width: 1.3em;
    height: 1.3em;
    float: left;
    margin-right: .5em;
    border-radius: 50%;
    margin-right: .2em;
    .cr-icon {
      position: absolute;
      font-size: .8em;
      line-height: 0;
      top: 50%;
      left: 20%;
    }
  }
  label input[type="radio"] {
    display: none;
    + .cr > .cr-icon {
      opacity: 0;
    }
    &:checked + .cr > .cr-icon {
      transform: scale(1) rotateZ(0deg);
      opacity: 1;
    }
    &:disabled + .cr {
      opacity: .5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Radio.vue?1a749efd